import {getCurrentCountry} from '../../store/regional-settings-store';
import Axios from 'axios';
import debounce from 'lodash/debounce';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils';
import 'intl-tel-input/build/css/intlTelInput.min.css';

const trackingDelay = 1000;

function initPhoneInputComponent(app) {
    app.component('phone-input',
        {
            template: `#phone-input`,
            inheritAttrs: false,
            props: {
                inputClass: {required: false},
                modelValue: {required: false},
                errorLabel: {default: ''},
            },
            data() {
                return {
                    intlTelInput: null,
                    errorMessage: '',
                    isDropdownOpened: false,
                    phone: this.modelValue,
                };
            },
            emits: ['update:modelValue', 'phone-validation'],
            watch: {
                'phone.entered'() {
                    const isValid = this.validate();
                    if (!isValid) {
                        this._trackInvalidNumber(`/Utils/TrackIncorrectPhone?phone=${this.phone.entered}`,
                            this._isPhoneValid.bind(this));
                    }
                    this.phone.full = this.intlTelInput.getNumber();
                    this.phone.isValid = isValid;
                    this.$emit('update:modelValue', this.phone);
                },
            },
            methods: {
                changeCountry() {
                    this.phone.entered = this.$refs.input.value;
                },
                validate() {
                    const isValid = this._isPhoneValid();
                    this.$refs.input.setCustomValidity(isValid ? '' : 'phoneInvalid');
                    this.errorMessage = isValid ? null : this.errorLabel;
                    this.$emit('phone-validation', isValid, this.errorMessage);
                    return isValid;
                },
                clearErrorMessage() {
                    this.errorMessage = null;
                },
                _isPhoneValid() {
                    return this.phone.entered == null ||
                        this.phone.entered === '' ||
                        this.intlTelInput.isValidNumber() ||
                        this._isLifePhoneNumber();
                },
                _isLifePhoneNumber() {
                    return /(\+)?(375)?25(\d{7})/i.test(this.phone.entered);
                },
                _initializePhonePlugin(needToFormat, country) {
                    this.intlTelInput = intlTelInput(this.$refs.input,
                        {
                            initialCountry: country,
                            autoPlaceholder: 'off',
                            preferredCountries: [country],
                            formatOnDisplay: needToFormat,
                            utilsScript: 'intl-tel-input/build/js/utils.js',
                        });
                },
                _addDropdownListeners() {
                    const instance = this;
                    this.$el.addEventListener('open:countrydropdown',
                        function() {
                            instance.isDropdownOpened = true;
                        });
                    this.$el.addEventListener('close:countrydropdown',
                        function() {
                            instance.isDropdownOpened = false;
                        });
                },
                _addMobileDropdownListeners() {
                    const instance = this;
                    this.$el.addEventListener('open:countrydropdown',
                        function() {
                            const dropdownContainer = instance.$el.querySelector('.flag-container');
                            const dropdown = document.getElementById('country-listbox');
                            dropdownContainer.append(dropdown);
                            document.querySelector('.intl-tel-input.iti-container').remove();
                        });
                },
                _trackInvalidNumber: debounce((updateUrl, isPhoneValid) => {
                    if (!isPhoneValid()) {
                        Axios.get(updateUrl);
                    }
                },
                trackingDelay),
            },
            mounted() {
                let country = getCurrentCountry();

                if (country.toLowerCase() === 'uk') {
                    country = 'gb';
                }

                this._initializePhonePlugin(false, country);
                if (this.intlTelInput.getSelectedCountryData().iso2 === country) {
                    this.intlTelInput.destroy();
                    this._initializePhonePlugin(true, country);
                    this.changeCountry();
                }

                this._addDropdownListeners();
                // replace intl-tel-input dropdown with custom for mobile
                const isMobile =
                    /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                if (isMobile) {
                    document.querySelector('body').classList.remove('iti-mobile');
                    this._addMobileDropdownListeners();
                }
            },
        });
}

export default initPhoneInputComponent;
